import React from 'react';
// import Utils from 'Common/Utils'
// import { Tooltip } from 'react-tooltip'
/**
 * tooltip with info icon
 * 
 * @param props 
 * @param {string} props.message - message for the tooltip
 * @returns 
 */
const TooltipInfo = (props: {message: string}) => {
   // const tooltipId = Utils.generate_file_name(5)
    return <></>
// @todo resize observer error
    // return (
    //     <span>
    //         <i className={`fas fa-info-circle`} data-tooltip-id={`delta-table-${tooltipId}`} data-tooltip-content={props.message}/>
    //         <Tooltip 
    //             className={`tw-max-w-[210px] tw-break-normal tw-p-0.5 tw-whitespace-normal tw-absolute`}
    //             id={`delta-table-${tooltipId}`} 
    //             place={"bottom"}>
    //         </Tooltip>
    //     </span>
    // )
}

export default TooltipInfo